// src/pages/Home.jsx
import React from "react";
import { useNavigate, Link } from "react-router-dom";
// Utilise PUBLIC_URL pour éviter les problèmes de casse et de résolutions en dev/prod
// L'image est dans le dossier public (racine), pas dans /assets
const logoSrc = `${process.env.PUBLIC_URL || ''}/logo-educCapsule.png`;
import homeBg from "../assets/home-bg.png"; // <-- ajoute l'image ici (client/src/assets/)

// PRIX ANNUEL
const YEAR_PRICE = 600;
const YEAR_CODE_PRICE = 550;
const fmtDH = (n) => `${n}\u00A0DH`;

export default function Home() {
  const nav = useNavigate();

  const gradientBg = {
    background:
      "radial-gradient(1200px 500px at 20% 0%, rgba(232, 241, 255, 0.9) 0%, rgba(247, 251, 255, 0.8) 40%, rgba(255, 255, 255, 0.7) 75%)",
  };
  const gradientText = {
    background:
      "linear-gradient(90deg, #2f80ed 0%, #56ccf2 35%, #7F56D9 70%, #A855F7 100%)",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    color: "transparent",
  };
  const wave = (
    <svg
      viewBox="0 0 1440 100"
      preserveAspectRatio="none"
      style={{ position: "absolute", left: 0, right: 0, bottom: -1, width: "100%", height: 100 }}
    >
      <path
        d="M0,64L60,64C120,64,240,64,360,53.3C480,43,600,21,720,21.3C840,21,960,43,1080,48C1200,53,1320,43,1380,37.3L1440,32L1440,100L1380,100C1320,100,1200,100,1080,100C960,100,840,100,720,100C600,100,480,100,360,100C240,100,120,100,60,100L0,100Z"
        fill="rgba(255, 255, 255, 0.8)"
      />
    </svg>
  );

  const openWhatsApp = (number) => {
    const message = "Bonjour, je suis intéressé(e) par EducCapsule et j'aimerais avoir plus d'informations.";
    const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <>
      {/* ---- Calque d'arrière-plan global (aucune modif du contenu) ---- */}
      <div
        className="home-bg"
        aria-hidden="true"
        style={{ "--home-bg": `url(${homeBg})` }}
      />

      {/* HERO */}
      <section className="position-relative border-0" style={gradientBg}>
        <div className="container py-5 text-center">
          <img
            src={logoSrc}
            alt="EducCapsule"
            width={140}
            height={140}
            className="mb-2 shadow-sm"
            style={{ borderRadius: 18, objectFit: "cover", userSelect: "none" }}
            draggable={false}
          />

          <div className="mb-3">
            <span className="badge rounded-pill text-bg-primary px-3 py-2">
              Nouveau • Bac 2025
            </span>
          </div>

          <h1 className="fw-bold mb-3" style={{ fontSize: "clamp(28px, 4vw, 44px)" }}>
            Réussis ton Bac avec des{" "}
            <span style={gradientText}>capsules</span> claires & des{" "}
            <span style={gradientText}>lives</span> chaque semaine
          </h1>

          {/* Texte avec prix ANNUEL 600 / 550 */}
          <p className="lead text-dark mx-auto" style={{ maxWidth: 820 }}>
            Cours courts et efficaces, 5 profs experts, suivi intelligent. Accède à tout le
            contenu après validation de ton reçu ({fmtDH(YEAR_PRICE)} / an) — ou{" "}
            {fmtDH(YEAR_CODE_PRICE)} avec un code parrainage.
          </p>

          <div className="d-flex gap-2 justify-content-center mt-3">
            <button className="btn btn-primary btn-lg px-4" onClick={() => nav("/eleve")}>
              Commencer maintenant
            </button>
            <Link to="/abonnement" className="btn btn-outline-secondary btn-lg px-4">
              Voir l'abonnement
            </Link>
          </div>

          <div className="text-dark small mt-3">
            Accès sécurisé • Connexion Google uniquement
          </div>
        </div>
        {wave}
      </section>

      {/* SECTIONS */}
      <section className="container py-5">
        {/* cartes */}
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card h-100 shadow-sm border-0 transparent-card">
              <div className="card-body">
                <div className="mb-2" style={{ fontSize: 28 }}>🎯</div>
                <h5 className="card-title">Capsules ultra-claires</h5>
                <p className="card-text text-dark">
                  Des vidéos courtes qui vont droit à l'essentiel + fiches pour réviser vite.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card h-100 shadow-sm border-0 transparent-card">
              <div className="card-body">
                <div className="mb-2" style={{ fontSize: 28 }}>🧪</div>
                <h5 className="card-title">Exercices corrigés</h5>
                <p className="card-text text-dark">
                  QCM, sujets types & corrections détaillées pour t'entraîner comme au Bac.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card h-100 shadow-sm border-0 transparent-card">
              <div className="card-body">
                <div className="mb-2" style={{ fontSize: 28 }}>🗓️</div>
                <h5 className="card-title">Lives hebdomadaires</h5>
                <p className="card-text text-dark">
                  Pose tes questions en direct aux profs et débloque les notions qui coincent.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* matières */}
        <h2 className="text-center mt-5 mb-4 text-dark" style={{ fontSize: "clamp(22px, 3vw, 34px)" }}>
          Matières couvertes
        </h2>
        <div className="row g-3 justify-content-center">
          {["Physique-Chimie", "Mathématiques", "SVT", "Philosophie", "Anglais"].map((m) => (
            <div className="col-sm-6 col-md-4 col-lg-3" key={m}>
              <div className="card h-100 shadow-sm border-0 transparent-card">
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title text-dark">{m}</h5>
                  <p className="card-text text-dark mb-3">
                    Capsules + exercices corrigés. Lives chaque semaine.
                  </p>
                  <button className="btn btn-outline-primary mt-auto" onClick={() => nav("/eleve")}>
                    Explorer
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* comment ça marche */}
        <h2 className="text-center mt-5 mb-4 text-dark" style={{ fontSize: "clamp(22px, 3vw, 34px)" }}>
          Comment ça marche ?
        </h2>
        <div className="row g-4">
          <div className="col-lg-4">
            <div className="card h-100 border-0 transparent-card">
              <div className="card-body">
                <h5 className="text-dark">1) Connexion</h5>
                <p className="text-dark">Connecte-toi avec Google — simple et sécurisé.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 border-0 transparent-card">
              <div className="card-body">
                <h5 className="text-dark">2) Dépôt du reçu</h5>
                <p className="text-dark">
                  Dépose ton reçu ({fmtDH(YEAR_PRICE)} ou {fmtDH(YEAR_CODE_PRICE)} avec parrainage).
                  Validation rapide par l'équipe.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 border-0 transparent-card">
              <div className="card-body">
                <h5 className="text-dark">3) Accès immédiat</h5>
                <p className="text-dark">
                  Accède aux 5 matières + aux lives. Objectif : la mention !
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CONTACT WHATSAPP */}
        <div className="row mt-5">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow-sm border-0 bg-success bg-opacity-90 text-white">
              <div className="card-body text-center p-4">
                <div className="mb-3" style={{ fontSize: 48 }}>💬</div>
                <h3 className="mb-3">Questions ? Contactez-nous sur WhatsApp</h3>
                <p className="mb-4 opacity-90">
                  Nos équipes sont disponibles pour répondre à toutes vos questions sur les cours, l'abonnement, ou le code parrainage.
                </p>
                
                <div className="row g-3 justify-content-center">
                  <div className="col-md-6">
                    <div className="bg-light bg-opacity-20 rounded p-3">
                      <div className="fw-bold mb-2">📞 Numéro 1</div>
                      <div className="h5 mb-3 phone-number">0663 300 784</div>
                      <button 
                        className="btn btn-light btn-sm w-100"
                        onClick={() => openWhatsApp("212663300784")}
                      >
                        <i className="fab fa-whatsapp me-2"></i>
                        Contacter sur WhatsApp
                      </button>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="bg-light bg-opacity-20 rounded p-3">
                      <div className="fw-bold mb-2">📞 Numéro 2</div>
                      <div className="h5 mb-3 phone-number">0663 082 632</div>
                      <button 
                        className="btn btn-light btn-sm w-100"
                        onClick={() => openWhatsApp("212663082632")}
                      >
                        <i className="fab fa-whatsapp me-2"></i>
                        Contacter sur WhatsApp
                      </button>
                    </div>
                  </div>
                </div>

                <div className="mt-4 pt-3 border-top border-light border-opacity-50">
                  <small className="opacity-90">
                    Réponse rapide garantie • Du lundi au vendredi, 9h-18h
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PRIX (ANNUEL 600/550) */}
        <div className="row mt-5">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow-sm border-0 transparent-card">
              <div className="card-body text-center">
                <h3 className="mb-1 text-dark">Abonnement annuel</h3>
                <div className="display-6 fw-bold text-primary">
                  {fmtDH(YEAR_PRICE)} <span className="text-dark fs-6">/ an</span>
                </div>
                <div className="text-success">
                  ou <strong>{fmtDH(YEAR_CODE_PRICE)}</strong> avec <strong>code parrainage</strong>
                </div>
                <button className="btn btn-primary btn-lg mt-3" onClick={() => nav("/eleve")}>
                  Je m'inscris
                </button>
                <p className="text-dark small mt-2 mb-0">
                  Paiement sécurisé • Accès après validation du reçu
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="row mt-5">
          <div className="col-lg-10 mx-auto">
            <h3 className="mb-3 text-dark">Questions fréquentes</h3>
            <div className="accordion" id="faq">
              <div className="accordion-item transparent-card">
                <h2 className="accordion-header" id="q1">
                  <button
                    className="accordion-button transparent-accordion"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#c1"
                    aria-expanded="true"
                    aria-controls="c1"
                  >
                    Comment profiter de la réduction de 50&nbsp;DH ?
                  </button>
                </h2>
                <div id="c1" className="accordion-collapse collapse show" data-bs-parent="#faq">
                  <div className="accordion-body transparent-accordion">
                    Demande un <strong>code parrainage</strong> à l'un de nos professeurs partenaires.
                    Puis, dans <em>Espace élève → Parrainages</em> (ou lors du dépôt du reçu), saisis le code :
                    le prix passe de <strong>{fmtDH(YEAR_PRICE)}</strong> à{" "}
                    <strong>{fmtDH(YEAR_CODE_PRICE)}</strong> pour l'année.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Styles locaux du fond (scopés à ce composant) */}
      <style>{`
        .home-bg {
          position: fixed;
          inset: 0;
          z-index: -1;                     /* derrière tout */
          background-image: var(--home-bg);
          background-size: cover;          /* couvre l'écran */
          background-position: center;
          background-repeat: no-repeat;
          background-attachment: fixed;    /* effet smooth sur desktop */
          transform: translateZ(0);        /* perf mobile */
        }
        .home-bg::after {
          content: "";
          position: absolute;
          inset: 0;
          /* voile léger pour lisibilité, reste discret */
          background: linear-gradient(0deg, rgba(0,0,0,.18), rgba(0,0,0,.08));
        }
        /* Sur mobile/tablette on évite le 'fixed' (meilleur rendu iOS/Android) */
        @media (max-width: 991.98px) {
          .home-bg { background-attachment: scroll; }
        }
        
        /* Amélioration de la lisibilité du texte sur fond transparent */
        section.container {
          background: transparent;
        }

        /* Cartes transparentes */
        .transparent-card {
          background: rgba(255, 255, 255, 0.7) !important;
          backdrop-filter: blur(10px);
        }

        /* Accordéon transparent */
        .transparent-accordion {
          background: rgba(255, 255, 255, 0.7) !important;
          backdrop-filter: blur(10px);
        }

        /* Numéros de téléphone visibles */
        .phone-number {
          color: #000 !important;
          font-weight: bold;
        }
      `}</style>
    </>
  );
}
